import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const ToggleAssignFollowersForDeliverablesMutation = input =>
  new Promise((resolve, reject) => {
    commitMutation(getEnvironment(), {
      mutation: graphql`
        mutation ToggleAssignFollowersForDeliverablesMutation(
          $input: ToggleAssignFollowersForDeliverablesInput!
        ) {
          toggleAssignFollowersForDeliverables(input: $input) {
            success
            clientMutationId
          }
        }
      `,
      variables: {
        input
      },
      onCompleted: resolve,
      onError: reject
    });
  });

export default ToggleAssignFollowersForDeliverablesMutation;
